export enum ValueBasedTriggerType {
 AtValue,
 IncrementByValue
}
